import { translateManager as t } from 'services/TranslateManager'
import { numberToText } from '../../../../utils/utils'
import { promoCodeManager } from 'services/PromoCodeManager'
import { PromoCodeInfoBox } from './PromoCodesSummaryItems/PromoCodeInfoBox'
import SummaryItem from 'components/SummaryItem/SummaryItem'

function NoTilesSelectedOrderSummary({ data }) {
  let freeTilesText = ''
  if (data.unusedFreeTiles) {
    if (data.unusedFreeTiles > 1) {
      freeTilesText = t.get(
        'order.checkout.payment_summary_rows.will_be_free_many',
        { v1: numberToText(data.unusedFreeTiles) }
      )
    } else {
      freeTilesText = t.get(
        'order.checkout.payment_summary_rows.will_be_free_one'
      )
    }
    freeTilesText = `, ${freeTilesText}`
  }

  const discountType = promoCodeManager.getDiscountCouponType()
  const hasPromoCode = data.freeTilesData?.freeTilesCreditTotal || discountType

  return (
    <div className="order-summary-container">
      {hasPromoCode ? (
        <PromoCodeInfoBox
          data={data}
          hasFreeTiles={!!data.freeTilesData?.freeTilesCreditTotal}
        />
      ) : (
        <div className="separator" />
      )}
      <SummaryItem
        className="no-tiles"
        text={`${t.get(
          'order.checkout.payment_summary_rows.select_some_tiles'
        )}${freeTilesText}`}
      />
    </div>
  )
}

export default NoTilesSelectedOrderSummary
